import '../../styles/components/modal.css';
import MicroModal from 'micromodal';

/*
  Example options

  onShow: modal => console.info(`${modal.id} is shown`),
  onClose: modal => console.info(`${modal.id} is hidden`),
  openTrigger: 'data-custom-open',
  closeTrigger: 'data-custom-close',
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: false,
  awaitOpenAnimation: false,
  awaitCloseAnimation: false,
  debugMode: true
*/

/**
 * Initializes a modal with options
 * @param {*} options Options for initialization
 */
export default function modal(options = {}) {
  return MicroModal.init(options);
}
